import React, { Component } from "react";

import StandardLayout from "components/Library/Layout/containers/StandardLayout";
import Header from "../../../components/Library/Header";
import UpcomingEvents from "../UpcomingEvents";
import PassedEvents from "../PassedEvents";

import styles from "./Events.css";

class Events extends Component {
  render() {
    return (
      <React.Fragment>
        <Header className={styles.events} text="Events" />;
        <StandardLayout
          mainAriaLabel="Events"
          main={
            <React.Fragment>
              <UpcomingEvents />
              <PassedEvents story={this.props.story} />
            </React.Fragment>
          }
        />
      </React.Fragment>
    );
  }
}

export default Events;
